import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const WindowWifi = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 14" {...props}>
    <path
      d="M6.07031 11.0298C6.07031 11.5049 6.261 11.9605 6.60042 12.2964C6.93984 12.6324 7.4002 12.8211 7.88022 12.8211C8.36024 12.8211 8.82059 12.6324 9.16002 12.2964C9.49944 11.9605 9.69012 11.5049 9.69012 11.0298C9.69012 10.5547 9.49944 10.0991 9.16002 9.76318C8.82059 9.42725 8.36024 9.23853 7.88022 9.23853C7.4002 9.23853 6.93984 9.42725 6.60042 9.76318C6.261 10.0991 6.07031 10.5547 6.07031 11.0298Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M11.0783 7.86467C10.2298 7.02496 9.07895 6.55322 7.879 6.55322C6.67904 6.55322 5.52823 7.02496 4.67969 7.86467"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9997 5.96465C11.642 4.62104 9.8007 3.86621 7.88072 3.86621C5.96074 3.86621 4.11939 4.62104 2.76172 5.96465"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6681 3.82425C12.8253 2.1244 10.4 1.1792 7.88092 1.1792C5.36187 1.1792 2.93649 2.1244 1.09375 3.82425"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
